<template>
    <CobVueSuggestion :items="items"
                      v-model="item"
                      :minLen="1"
                      :setLabel="setLabel"
                      :itemTemplate="ItemTemplate"
                      inputClasses="rm-task-assignee"
                      wrapperClasses="rm-task-assignee-search"
                      :placeholder='i18n.searchUser'
                      @changed="inputChange"
                      @selected="itemSelected"
                      @enter="keyEnter"
                      @escape="keyEscape"
    >
    </CobVueSuggestion>
</template>


<script>
    import CobVueSuggestion from './cob-vue-suggestion.vue'
    import axios from "axios";

    const ItemTemplate = {
       template: `
          <div>
              <span class="item-username">{{item.username}}</span><br>
              <abbr class="item-name">{{ item.name }}
                  <span class="item-email">({{item.email}} {{item.contact}} )</span>
              </abbr>
          </div>`,
       props: {
          item: { required: true }
       }
    }

    export default {
        components: {
            CobVueSuggestion
        },
        props: {
            usermBaseUrl: String,
            value: Object,
            i18n: Object,
            fixedItems: {
               required: false,
               type: Array
            }
        },
        data() {
            return {
                item: undefined,
                items: [],
                ItemTemplate
            }
        },
        methods: {
            setLabel(item) {
                return item !== null ? item.username : "";
            },
            itemSelected(item) {
                const assignee = (item !== undefined ? {uri: item._links.self, username: item.username} : undefined);
                this.item = assignee;

                this.$emit('input', assignee); //send it back to tasks
                this.$emit('enter'); // faster list close
            },
            inputChange(text) {
               if(this.fixedItems){
                  this.items = this.fixedItems;
                  return;
               }

                const searchUrl = this.usermBaseUrl + "/userm/user/search?size=50&q=" + encodeURIComponent(text) + "*";
                console.debug(searchUrl);
                axios.get(searchUrl)
                    .then((response) => {
                        console.debug(response);
                        this.items = response.data
                    })
                    // eslint-disable-next-line dot-notation
                    .catch((err) => {
                        console.error("Error searching userm", err);
                    });
            },
            keyEnter() {
                this.$emit('enter');
            },
            keyEscape() {
                this.$emit('escape');
            }
        }
    }

</script>

<style>
</style>
